import React from 'react';
import {Row,Modal} from 'antd';
import {connect} from 'react-redux';
import {app_SET} from '../redux/actions/appAction';

class ModalBase extends React.Component {
	
	render(){
		
		const {app} = this.props;
		const {offline} = app;
	
		return (
		
			
			<Modal visible={offline} keyboard={false} closable ={false} footer={null}>
			
				您的网络掉线了		
			
			
			</Modal>
			
			 
		)
	
	}
	
}


 const mapStateToProps = (state) => {
  return {
    app: state.appReducer   
	}
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {  	
	app_set: (value)=>dispatch(app_SET(value))		
	}
}

const OfflineModal =connect(mapStateToProps,mapDispatchToProps)(ModalBase);

export default OfflineModal;
